import { Button } from 'antd';
import { Promo } from '@/components/Promo';
import { getLoggedInUser, getSelectedAgent } from '@/store/account/selector';
import { useAppSelector } from '@/store/hooks/useAppSelector';
import { BOOK_CALL_CALENDLY_URL } from 'src/constants';
import { useDispatch } from 'react-redux';
import { ReceptionistDashboardSiderItem } from 'src/enums/EReceptionistDashboardSiderItem';
import { setCurrentPage } from '@/store/account/slice';
import { updateOnboardingInfo } from '@/store/resellerOnboardingSteps/slice';

const ReceptionistPromo = () => {
	const loggedInUser = useAppSelector(getLoggedInUser);
	const selectedAgent = useAppSelector(getSelectedAgent);
	const dispatch = useDispatch();
	const handleSetupCallNowClick = () => {
		window.open(
			`${BOOK_CALL_CALENDLY_URL}?a1=${encodeURIComponent(selectedAgent?.number || '')}`,
			'_blank',
		);
	};

	return (
		<>
			<Promo>
				<div className="flex flex-col md:flex-row items-center justify-between w-full gap-4 bg-[#f1f5f9]">
					<div className="w-full md:w-auto text-center md:text-left mb-4 md:mb-0">
						Schedule a <strong>complimentary onboarding session</strong> with our team for
						personalized setup assistance.
					</div>
					<div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto justify-center md:justify-end">
						{loggedInUser?.resellerClient && loggedInUser?.inboundDemo && (
							<Button
								onClick={() => {
									dispatch(updateOnboardingInfo({ testingCompleted: true }));
								}}
								className="bg-white hover:bg-gray-50 text-blue-600"
							>
								Start Reselling
							</Button>
						)}
						<Button
							onClick={handleSetupCallNowClick}
							className="bg-white hover:bg-gray-50 text-blue-600"
						>
							Book Call Now
						</Button>
						<Button
							onClick={() =>
								dispatch(setCurrentPage(ReceptionistDashboardSiderItem.CONTACT_SUPPORT))
							}
							className="bg-white text-blue-600 hover:bg-gray-50"
						>
							Contact Support
						</Button>
					</div>
				</div>
			</Promo>
		</>
	);
};

export default ReceptionistPromo;
